import type { Translations } from './types'

export const es: Translations = {
  common: {
    stationUnknown: (nr) => `La estación ${nr} aún no está activa.`,
    stationOffline: 'Sin conexión — vuelve a escanear más tarde.',
    toMap: 'Ir al mapa',
    more: 'Más',
    images: 'Imágenes',
    retry: 'Reintentar',
    back: 'Atr\u00E1s',
    close: 'Cerrar',
    processing: 'Iniciando sesi\u00F3n\u2026',
  },

  landing: {
    hero: {
      title: 'Experimenta la naturaleza en\nRealidad Aumentada',
      subtitle: (count) =>
        `Descubre la flora y fauna de la Tscheppaschlucht \u2014 ${count} especies, interactivas y al alcance de tu mano.`,
      cta: 'Explorar',
      secondaryCta: 'Crear cuenta',
    },
    intro: {
      heading: 'La garganta\ncobra vida',
      text: (count) =>
        `TSCHAPP da vida a la Tscheppaschlucht en Ferlach. Con Realidad Aumentada puedes explorar m\u00E1s de ${count} especies animales y vegetales aut\u00F3ctonas directamente en su h\u00E1bitat natural \u2014 con descripciones detalladas, art\u00EDculos generados por inteligencia artificial y modelos 3D inmersivos.`,
    },
    stats: {
      animals: 'Especies animales',
      plants: 'Especies vegetales',
      ar: 'Augmented Reality',
    },
    community: {
      heading: '\u00DAnete a la comunidad',
      text: 'Con una cuenta puedes dar like a especies, dejar comentarios y experimentar la Tscheppaschlucht junto a otros amantes de la naturaleza.',
      features: {
        like: {
          title: 'Da like a especies',
          description:
            'Marca tus especies favoritas y crea tu colecci\u00F3n personal',
        },
        comment: {
          title: 'Comenta',
          description:
            'Comparte tus conocimientos y conecta con otros amantes de la naturaleza',
        },
        ar: {
          title: 'Experimenta AR',
          description:
            'Descubre las especies en Realidad Aumentada directamente en la garganta',
        },
      },
      registerWithGoogle: 'Reg\u00EDstrate con Google',
    },
    routes: {
      heading: 'Tres caminos, una experiencia',
      text: 'Todas las rutas comienzan en el centro de visitantes y atraviesan la Tscheppaschlucht. En la bifurcaci\u00F3n eliges tu aventura.',
      stations: 'Estaciones',
      detailLink: 'Todas las rutas en detalle',
    },
    stories: {
      heading: 'Historias de la garganta',
      text: 'Leyendas, mitos y las historias de nuestras mascotas \u2014 contadas como audiolibro interactivo con ilustraciones generadas por IA.',
      narratorTschauko: 'Narrado por Tschauko',
      narratorTschauka: 'Narrado por Tschauka',
      scenes: 'Escenas',
      allLink: 'Todas las historias',
    },
    featured: {
      heading: 'Especies destacadas',
      discoverLink: (count) => `Descubre las ${count} especies`,
    },
  },

  browse: {
    badge: 'Flora & Fauna',
    heroTitle: 'Flora & Fauna',
    heroSubtitle: 'Descubre la fauna y flora de la Tscheppaschlucht',
    speciesCount: (count) => `${count} especies`,
    filterAll: 'Todas',
    logout: 'Cerrar sesi\u00F3n',
    login: 'Iniciar sesi\u00F3n',
    authBanner: 'Inicia sesi\u00F3n para dar like a especies y dejar comentarios',
    close: 'Cerrar',
  },

  species: {
    loading: 'Cargando objeto...',
    analyzing: 'Analizando objeto...',
    loading3d: 'Cargando modelo 3D...',
    preparing3d: 'Preparando el modelo 3D …',
    load3dFailed: 'No se pudo cargar el modelo 3D.',
    arStartFailed: 'No se pudo iniciar la RA. Comprueba el permiso WebXR del navegador.',
    notFound: 'Objeto no encontrado',
    analysisFailed: 'An\u00E1lisis fallido',
    noId: 'No se proporcion\u00F3 ID',
    brandSubtitle: 'Experimenta la naturaleza en Realidad Aumentada',
    featuresCount: (count) => `${count} caracter\u00EDsticas`,
    share: 'Compartir',
    like: 'Me gusta',
    unlike: 'Ya no me gusta',
    comments: 'Comentarios',
    audioGuide: {
      label: 'Gu\u00EDa de audio',
      subtitle: 'Escuchar descripci\u00F3n',
      noAudio: 'Sin audio',
    },
    pause: 'Pausa',
    play: 'Reproducir',
    stopMusic: 'Detener m\u00FAsica',
    view2d: 'Vista 2D',
    view3d: 'Vista 3D',
    commentsSection: {
      title: (count) => `Comentarios (${count})`,
      empty: 'A\u00FAn no hay comentarios. \u00A1S\u00E9 el primero!',
      placeholder: 'Escribe un comentario...',
      delete: 'Eliminar',
    },
    close: 'Cerrar',
    back: 'Atr\u00E1s',
  },

  routes: {
    headerTitle: 'Rutas de senderismo',
    heroTitle: 'Tres caminos a trav\u00E9s\nde la garganta',
    heroSubtitle:
      'Todas las rutas comienzan en el centro de visitantes y atraviesan la impresionante Tscheppaschlucht. En la bifurcaci\u00F3n decides qu\u00E9 aventura te espera.',
    stats: {
      kilometers: 'Kil\u00F3metros',
      walkingTime: 'Tiempo de caminata',
      stations: 'Estaciones',
    },
    sections: {
      routeCourse: 'Resumen de la ruta',
      elevationProfile: 'Perfil de elevaci\u00F3n',
      stations: 'Estaciones',
    },
    listToggle: 'Lista',
    loading3d: 'Cargando vista 3D\u2026',
    elevationMin: 'm\u00EDn',
    elevationMax: 'm\u00E1x',
    back: 'Atr\u00E1s',
    details: {
      listenDescription: 'Escuchar la descripción',
      stopListening: 'Detener',
      listenRoute: 'Escuchar la ruta',
      guideLive: 'Dr. Tschauko en directo',
      nextStations: 'Próximas estaciones',
    },
  },

  stories: {
    languageFallback: 'Por ahora esta leyenda solo está disponible en alemán.',
    badge: 'Leyendas e historias',
    pageTitle: 'Leyendas e historias',
    pageSubtitle:
      'Los mitos y leyendas de la Tscheppaschlucht \u2014 narrados por Tschauko & Tschauka',
    narratorTschauko: '\uD83E\uDD89 Narrado por Tschauko',
    narratorTschauka: '\uD83D\uDC38 Narrado por Tschauka',
    chapterCounter: (current, total) => `Cap\u00EDtulo ${current} de ${total}`,
    chapterCount: (count) => `${count} cap\u00EDtulos`,
    startAudiobook: 'Iniciar audiolibro',
    closeAudiobook: 'Cerrar audiolibro',
    previousChapter: 'Cap\u00EDtulo anterior',
    nextChapter: 'Cap\u00EDtulo siguiente',
    done: 'Hecho',
    chapterN: (n) => `Cap\u00EDtulo ${n}`,
    toggleMode: 'Cambiar modo',
    photoBackground: 'Fondo fotogr\u00E1fico',
    back: 'Atr\u00E1s',
  },

  footer: {
    tagline:
      'Experimenta la naturaleza en Realidad Aumentada.',
    legal: {
      title: 'Legal',
      imprint: 'Aviso legal',
      privacy: 'Pol\u00EDtica de privacidad',
      terms: 'Condiciones de uso',
    },
    contact: 'Contacto',
    more: {
      title: 'M\u00E1s',
      floraFauna: 'Flora & Fauna',
    },
    sponsoredBy: 'Con el apoyo de',
    copyright: (year) => `\u00A9 ${year} TSCHAPP \u00B7 Todos los derechos reservados`,
  },

  units: {
    minuteShort: 'min',
    hourShort: 'h',
  },

  mapMarkers: {
    ticketOffice: 'Taquilla',
    receptionHouse: 'Centro de visitantes',
    goal: 'Meta',
  },

  legend: {
    title: 'Leyenda',
    mainRoute: 'Ruta principal',
    sideTrail: 'Sendero lateral',
    waterways: 'Cursos de agua',
    filterOnly: (kategorie: string) => `Mostrar solo ${kategorie}`,
    filterClear: 'Quitar filtro — mostrar todo',
    byDistance: 'Distancia',
    byName: 'Nombre',
  },

  nav: {
    home: 'Home',
    floraFauna: 'Flora & Fauna',
    routes: 'Hiking Trails',
    stories: 'Stories',
    login: 'Sign In',
    logout: 'Sign Out',
    myProfile: 'My Profile',
  },

  dialog: {
    register: {
      title: 'Registrarse',
      description:
        '\u00DAnete a la comunidad de la Tscheppaschlucht. Descubre la naturaleza en Realidad Aumentada.',
      nameLabel: 'Nombre',
      namePlaceholder: 'Tu nombre',
      emailLabel: 'Correo electr\u00F3nico',
      emailPlaceholder: 'nombre@ejemplo.com',
      passwordLabel: 'Contrase\u00F1a',
      passwordPlaceholder: 'M\u00EDn. 8 caracteres',
      submit: 'Crear cuenta',
      google: 'Registrarse con Google',
      alreadyRegistered: '\u00BFYa tienes cuenta?',
      loginLink: 'Iniciar sesi\u00F3n',
      or: 'o',
      emailSent: 'Te hemos enviado una confirmaci\u00F3n. \u00A1Puedes continuar ahora!',
      emailHint: 'Te avisaremos cuando TSCHAPP est\u00E9 disponible.',
    },
    login: {
      title: 'Iniciar sesi\u00F3n',
      description:
        'Da like a especies, deja comentarios y experimenta la Tscheppaschlucht junto a otros amantes de la naturaleza.',
      emailLabel: 'Correo electr\u00F3nico',
      emailPlaceholder: 'nombre@ejemplo.com',
      passwordLabel: 'Contrase\u00F1a',
      passwordPlaceholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022',
      submit: 'Iniciar sesi\u00F3n',
      google: 'Iniciar sesi\u00F3n con Google',
      noAccount: '\u00BFA\u00FAn no tienes cuenta?',
      registerLink: 'Registrarse',
    },
    survey: {
      title: 'Encuesta r\u00E1pida',
      description: 'Ay\u00FAdanos a mejorar TSCHAPP \u2014 4 preguntas r\u00E1pidas.',
      interestLabel: '\u00BFQu\u00E9 te interesa m\u00E1s?',
      interestOptions: {
        ar: 'Experiencia AR en la naturaleza',
        flora: 'Descubrir flora & fauna',
        routes: 'Rutas de senderismo',
        stories: 'Leyendas e historias',
      },
      visitLabel: '\u00BFCon qu\u00E9 frecuencia visitas la Tscheppaschlucht?',
      visitOptions: {
        never: 'Nunca',
        once: '1\u20132 veces',
        regular: 'Regularmente',
        local: 'Vivo cerca',
      },
      deviceLabel: '\u00BFQu\u00E9 dispositivo usas?',
      deviceOptions: {
        iphone: 'iPhone',
        android: 'Android',
      },
      wishLabel: '\u00BFQu\u00E9 te gustar\u00EDa que tuviera la app?',
      wishPlaceholder: 'Tus ideas (opcional)',
      submit: 'Enviar',
      skip: 'Omitir',
    },
  },

  navigation: {
    button: 'Navegación',
    title: 'Mapa',
    close: 'Cerrar mapa',
    centerOnUser: 'Centrar en mi ubicación',
    nearestPoint: 'Punto más cercano',
    distance: (meters) => meters < 1000 ? `${Math.round(meters)} m` : `${(meters / 1000).toFixed(1)} km`,
    learnMore: 'Más información',
    playAudio: 'Reproducir audio',
    locationPermissionDenied: 'Acceso a ubicación denegado',
    loadingMap: 'Cargando mapa…',
    noGps: 'Sin señal GPS',

    loadFailed: 'No se pudo cargar el mapa',
    aria: {
      zoomIn: 'Acercar',
      zoomOut: 'Alejar',
      recenter: 'Centrar en mi ubicación',
      followEnable: 'Seguir mi ubicación en el mapa',
      followDisable: 'Dejar de seguir mi ubicación',
    },
    aux: {
      storyGuideOpen: 'Abrir Story Guide',
      storyGuideClose: 'Cerrar Story Guide',
      aiCompanionStart: 'Iniciar acompañante IA',
      aiCompanionPause: 'Pausar acompañante IA',
      photoMap: 'Mostrar mapa fotográfico',
      vectorMode: 'Modo vectorial',
      diaryEnd: 'Terminar diario',
    },
    optionsSheet: {
      adventure: 'Aventura',
      performance: 'Rendimiento',
      map: 'Mapa',
      narrator: 'Narrador',
      voiceComing: 'Voz disponible pronto',
    },
    poiCard: {
      audioBtn: 'Audio',
      audioStop: 'Detener',
      moreBtn: 'Más →',
      endBtn: 'Terminar',
      metersAway: 'm de distancia',
      fromStart: 'desde el inicio',
      away: 'de distancia',
      sightLabel: 'Punto de interés',
    },
    // Routen-Karte (Picker) — Auswaehlen/Starten/Details (Alex 25.07.).
    /** Weggabelung: Routenwechsel direkt im Detail des Punktes
     *  (Alex 2026-08-11 — „wenn man da ist, will man vielleicht doch eine
     *  andere Route wandern"). */
    junction: {
      title: 'Desde aquí',
      hint: 'Aquí los caminos se bifurcan. Toca para cambiar de ruta.',
      active: 'Ruta activa',
    },
    routeCard: {
      select: 'Seleccionar',
      active: 'Activa',
      start: 'Iniciar ruta',
      details: 'Detalles',
    },
  },

  // Entdecken-Oberflaeche. NUR Bedienelemente — POI-Titel, Beschreibungen
  // und Kategorien kommen sprachselektiert aus ArTrack/knowledge-api.
  discover: {
    title: 'Descubrir',
    close: 'Cerrar',
    back: 'Atrás',
    searchPlaceholder: 'Busca lugares, historias, animales …',
    searchLabel: 'Buscar en Descubrir',
    categoryFilterLabel: 'Filtrar por categoría',
    detailLabel: 'Detalles del lugar',
    unavailable: 'Este lugar no está disponible actualmente.',
    highlights: 'Destacados',
    nearby: 'Cerca de ti',
    allPlaces: 'Todos los lugares',
    categories: 'Categorías',
    filterAll: 'Todos',
    unitSpecies: 'especies',
    unitPlaces: 'lugares',
    heroSubtitle: 'Historias, naturaleza y secretos del desfiladero Tscheppaschlucht.',
    openMap: 'Abrir el mapa',
    showAll: 'Ver todo',
    showOnMap: 'En el mapa',
    readAloud: 'Leer en voz alta',
    loading: 'Cargando contenidos …',
    nothingFound: (suche: string) => suche
      ? `Sin resultados para «${suche}».`
      : `Sin resultados en esta categoría.`,
    stopReading: 'Detener lectura',
  },

  footerNav: {
    profileSignIn: 'Perfil — iniciar sesión',
    profile: 'Perfil',
    map: 'Mapa',
    discover: 'Descubrir',
    chatBot: 'Dr. Tschauko',
    diary: 'Diario',
    debug: 'Debug',
    route: 'Ruta',
  },

  onboarding: {
    welcome: {
      title: '\u00A1Gracias por registrarte!',
      text: 'TSCHAPP te acerca a la naturaleza de la Tscheppaschlucht \u2014 con Realidad Aumentada, mapas interactivos e historias fascinantes. Aqu\u00ED tienes un breve resumen.',
    },
    flora: {
      title: 'Flora & Fauna',
      text: 'Descubre m\u00E1s de 80 especies animales y vegetales aut\u00F3ctonas con descripciones detalladas, modelos 3D y art\u00EDculos generados por IA. Dale like y comenta cada especie.',
    },
    stories: {
      title: 'Leyendas e Historias',
      text: 'Vive los mitos y leyendas de la Tscheppaschlucht como un audiolibro interactivo \u2014 narrado por nuestras mascotas Tschauko y Tschauka, ilustrado con arte generado por IA.',
    },
    routes: {
      title: 'Rutas de senderismo',
      text: 'Tres caminos \u00FAnicos atraviesan la garganta. Cada ruta tiene sus propias estaciones con experiencias AR, perfiles de elevaci\u00F3n y vistas 3D interactivas.',
    },
    next: 'Siguiente',
    prev: 'Atr\u00E1s',
    skip: 'Omitir',
    start: 'Empecemos',
  },

  expedition: {
    title: 'Mi expedición',
    progress: (found, total) => `${found} de ${total} secretos descubiertos`,
    nextSecret: 'Encuentra el próximo secreto',
    nextSecretSub: 'Sigue la próxima pista y explora la garganta.',
    today: 'Descubierto hoy',
    newFound: 'Recién descubierto',
    nextHint: 'Próxima pista',
    myFinds: 'Mis hallazgos',
    secretSlot: 'Secreto',
    emptyRoute: 'Aún no hay secretos registrados para este sendero.',
    badges: 'Insignias',
    badgeTracker: { title: 'Rastreador', text: 'Encuentras pistas que otros pasan por alto.' },
    badgePlants: { title: 'Experto en plantas', text: 'Conoces las plantas de la garganta.' },
    missionTitle: 'Tu misión',
    secretNofM: (n, m) => `Secreto ${n} de ${m}`,
    lookLike: 'Podría verse así',
    whatYouGet: 'Lo que obtienes',
    rewardFind: { title: 'Nuevo hallazgo', sub: 'Descubre algo especial.' },
    rewardProgress: { title: '+1 progreso', sub: 'Tu expedición sigue creciendo.' },
    rewardSecret: { title: '1 secreto más cerca', sub: 'Un paso más cerca de la solución.' },
    rewardFindDone: 'Este hallazgo se añadió a tu colección.',
    rewardSecretDone: 'Secreto resuelto',
    lookout: 'Estaré atento',
    foundIt: 'Lo encontré',
    later: 'Más tarde',
    fundTitle: 'Gran descubrimiento',
    solvedNofM: (n, m) => `Secreto ${n} de ${m} resuelto`,
    youFound: (name) => `Lo encontraste: ${name}.`,
    progressLabel: 'Progreso de la expedición',
    intoBook: 'Al libro de descubrimientos',
    learnMore: 'Saber más',
  },

  forschung: {
    title: 'Diario de investigación',
    subtitle: 'Registra y comprende tus observaciones.',
    newObservation: '+ Nueva observación',
    statBeobachtungen: 'Observaciones',
    statArten: 'Especies',
    statEntwuerfe: 'Borradores',
    drafts: 'Borradores',
    myEntries: 'Mis entradas',
    emptyEntries: 'Aún no hay observaciones. Lo que veas, oigas o encuentres en el camino tiene lugar aquí.',
    untitled: 'Sin título',
    status: { draft: 'Borrador', private: 'Privado', submitted: 'En revisión', published: 'Publicado', rejected: 'No publicado', queued: 'Esperando subida', queuedRetry: 'Reintentando subida' },
    newTitle: 'Nueva observación',
    gpsPending: 'El lugar se añadirá cuando el GPS esté disponible.',
    capFoto: 'Foto',
    capMediathek: 'Galería',
    capAudio: 'Audio',
    capAudioStop: (s) => `${s}s parar`,
    capVideo: 'Vídeo',
    mediaHint: (sec) => `Las fotos se reducen automáticamente para subirlas (HD). Vídeos: como máximo ${sec} segundos.`,
    videoTooLong: (sec, max) => `El vídeo dura ${sec} segundos — el diario permite como máximo ${max}, para que la subida funcione incluso con poca señal.`,
    videoTooBig: (mb, max) => `El vídeo es demasiado grande (${mb} MB). Graba como máximo ${max} segundos en HD.`,
    titleLabel: 'Título',
    noteLabel: 'Nota',
    notePlaceholder: '¿Qué observaste?',
    defaultTitleAt: (ort) => `Observación en ${ort}`,
    defaultTitle: 'Observación',
    artLabel: 'Vincular una especie (opcional)',
    artSearch: 'Buscar nombre de especie …',
    artUnlink: 'Quitar vínculo',
    save: 'Guardar entrada',
    saveHint: 'Se guarda en privado — visible solo para ti. Enviar a la comunidad es un paso aparte.',
    back: 'Atrás',
    suggest: 'Proponer para publicación',
    previewHeading: 'Así aparecerá tu aporte',
    previewHint: 'Tu entrada será revisada antes de aparecer en la comunidad.',
    submit: 'Enviar entrada',
    submitting: 'Enviando …',
    keepPrivate: 'Mantener privado',
    edit: 'Editar',
    delete: 'Eliminar entrada',
    deleteConfirm: '¿Eliminar la entrada definitivamente?',
    keep: 'Conservar',
    rejectedInfo: (reason) => `La redacción no publicó este aporte${reason ? `: ${reason}` : '.'} Tu entrada privada se conserva.`,
    submitFailed: (detail) => `El envío falló — la entrada sigue guardada en privado. (${detail})`,
    queuedInfo: (attempts) => `Enviado — la subida se hará en cuanto haya conexión${attempts ? ` (${attempts} intentos hasta ahora)` : ''}. Puedes cerrar la app; volverá a intentarlo la próxima vez.`,
    backToList: 'Volver al resumen',
    fallbackOrt: 'Tscheppaschlucht',
    community: 'Desde la garganta',
    communitySub: 'La comunidad descubre, comparte y preserva.',
  },
}
